import React, { useEffect, useState } from 'react'
import ReportsPdfData from '../ReportsPdfData/ReportsPdfData'
import reportpdfLogo from "../../assets/images/reportpdf-logo.png";
import { useContextValue } from '../../context/LoaderContext';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import useApi from '../../hook/useAPI';
import { MONTHS, REPORT } from '../../utils/const';
import { Dropdown } from 'react-bootstrap';
import { APIProvider } from '@vis.gl/react-google-maps';
import { GOOGLE_KEY } from '../../constants/Constant';
import { collectDeviceNamesFromReportsData, formatDeviceNamesList } from '../../utils/reportDevices';

function ReportPdf() {
  const { reportPdfRef } = useContextValue()

  const columnsOptions1 = [
    { header: "Device", key: 'device' },
    { header: "Status", key: 'status', },
    { header: "Location", key: 'location', },
    { header: "Command", key: 'command', },
    { header: "Battery", key: 'battery', },
    { header: "Date / Time", key: 'date' }
  ]
  const rowData1 = [
    {
      device: "LocShark Tablet #1",
      status: 'Moving',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      command: 'Clamp',
      battery: '56%',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #2",
      status: 'Parked',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      command: 'Clamp',
      battery: '56%',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #3",
      status: 'Moving',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      command: 'Clamp',
      battery: '56%',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #4",
      status: 'Idle',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      command: 'Clamp',
      battery: '56%',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #5",
      status: 'Offline',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      command: 'Clamp',
      battery: '56%',
      date: '25 Apr 2024 18:01:38'
    },
  ];
  const columnsOptions2 = [
    { header: "Device Name", key: 'device' },
    { header: "Start Location", key: 'startlocation', },
    { header: "End Location", key: 'endlocation', },
    { header: "Duration", key: 'duration', },
    { header: "Distance Traveled", key: 'distance', },
    { header: "Date / Time", key: 'date' }
  ]
  const rowData2 = [
    {
      device: "LocShark Tablet #1",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #2",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #3",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #4",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #5",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
  ];
  const columnsOptions3 = [
    { header: "Device Name", key: 'deviceName' },
    { header: "Zone Name", key: 'name', },
    { header: "Zone Address", key: 'location', },
    { header: "Duration", key: 'duration', },
    { header: "Distance Radius", key: 'distance', },
    { header: "Date / Time", key: 'date' }
  ]
  const rowData3 = [
    {
      deviceName: "LocShark Tablet #1",
      name: 'Zone A',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      deviceName: "LocShark Tablet #2",
      name: 'Zone B',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      deviceName: "LocShark Tablet #3",
      name: 'Zone C',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      deviceName: "LocShark Tablet #4",
      name: 'Zone D',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      deviceName: "LocShark Tablet #5",
      name: 'Zone E',
      location: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
  ];

  // states

  const [deviceName, setDeviceName] = useState("");
  const [timePeriod, setTimePeriod] = useState("");
  const [statusRowData, setStatusRowData] = useState([]);
  const [tripsData, setTripsData] = useState([]);
  const [zoneData, setZoneData] = useState([]);

  const { getData } = useApi();
  let getReportId = localStorage.getItem('current_report_export_id');
  const url = `${REPORT.GET_REPORT}/${getReportId}`;
  const element = reportPdfRef?.current;
  console.log(element);

  useEffect(() => {
    if (getReportId) {
      (async () => {
        const response = await getData(url);

        if (response.status && response.status === 200) {
          const report = response?.data?.report;
          let getDeviceTimePeriod = report?.startDate;
          let getDeviceTimePeriodEnd = report?.endDate;

          // get mapped data
          const reportsData = response?.data?.reportsData || [];
          const allDeviceStatuses = reportsData.flatMap((report) => report.deviceStatus);
          const allDeviceTrips = reportsData.flatMap((report) => report.trips);
          const allDeviceZoneActivities = reportsData.flatMap((report) => report.zoneActivities);

          // get status part

          const statusPromises = allDeviceStatuses.map(async (statusObj) => {
            let formattedDate = await formatDate(statusObj?.dateTime);
            const location = await getAddress(statusObj?.latitude, statusObj?.longitude);
            return {
              device: statusObj?.deviceName || "-",
              status: statusObj?.eventType || "-",
              location,
              command: statusObj?.command || '-',
              battery: `${statusObj?.batteryLevel || 0}%`,
              date: formattedDate
            };
          });
          const formattedData = await Promise.all(statusPromises);
          setStatusRowData(formattedData);
          const deviceNames = collectDeviceNamesFromReportsData(reportsData);
          setDeviceName(formatDeviceNamesList(deviceNames) || report?.name || '');
          if (getDeviceTimePeriod && getDeviceTimePeriodEnd) {
            let time = countDaysBetweenDates(getDeviceTimePeriod, getDeviceTimePeriodEnd) || 0;
            setTimePeriod(`${time + 1} ${time > 0 ? 'Days' : 'Day'}`);
          }

          // get trips part

          const tripsPromises = allDeviceTrips.map(async (tripsObj) => {
            let tripsArr = tripsObj.trips;
            // start and end
            let getStartPointLatitude = tripsArr[0]?.latitude;
            let getStartPointLongitude = tripsArr[0]?.longitude;
            let startLocation = await getAddress(getStartPointLatitude, getStartPointLongitude);

            let getEndPointLatitude = tripsArr[tripsArr.length - 1].latitude;
            let getEndPointLongitude = tripsArr[tripsArr.length - 1].longitude;
            let endLocation = await getAddress(getEndPointLatitude, getEndPointLongitude);

            let deviceName = tripsArr[0]?.deviceName;



            // Get Distance

            const distance = await _getDistanceByLatLong(getStartPointLatitude, getStartPointLongitude, getEndPointLatitude, getEndPointLongitude);
            let duration = '-';
            if (distance && distance !== '-' && tripsArr[0]?.speed) {
              duration = parseFloat(distance) / parseFloat(tripsArr[0]?.speed);
            }
            const startTime = new Date(tripsArr[0]?.dateTime);

            const endTime = new Date(tripsArr[tripsArr?.length - 1]?.dateTime);
            let formattedDate = await formatDate(endTime);
            const formattedDuration = await _getDuration(startTime, endTime);


            return {
              device: deviceName || "-",
              startlocation: startLocation,
              endlocation: endLocation,
              duration: formattedDuration,
              distance: distance || '-',
              date: formattedDate
            };
          });

          const tripsFormattedData = await Promise.all(tripsPromises);
          setTripsData(tripsFormattedData);

          // get zone activities

          const zonePromises = allDeviceZoneActivities.map(async (zoneObj) => {
            let zoneArr = zoneObj.zoneActivities;
            // start and end
            let getStartPointLatitude = zoneArr[0]?.zoneLatitude;
            let getStartPointLongitude = zoneArr[0]?.zoneLongitude;
            let zoneAddress = await getAddress(getStartPointLatitude, getStartPointLongitude);


            let deviceName = zoneArr[0]?.deviceName;
            let dateTime = zoneArr[0]?.dateTime;
            let zoneName = zoneArr[0]?.zoneName;
            let zoneRadius = zoneArr[0]?.zoneRadius;

            let zoneEndLatitude = zoneArr[zoneArr.length - 1].zoneLatitude;
            let zoneEndLongitude = zoneArr[zoneArr.length - 1].zoneLongitude;


            // Get Distance
            const startTime = new Date(zoneObj.zoneActivities[0]?.dateTime);
            const endTime = new Date(zoneObj?.zoneActivities[zoneObj?.zoneActivities?.length - 1]?.dateTime);

            const formattedDuration = await _getDuration(startTime, endTime);
            let formattedDate = await formatDate(endTime);


            return {
              deviceName: deviceName,
              name: zoneName,
              location: zoneAddress || '-',
              duration: formattedDuration || '-',
              distance: zoneRadius ? `${zoneRadius} miles` : '-',
              date: formattedDate
            }

          });

          const zoneFormattedData = await Promise.all(zonePromises);
          setZoneData(zoneFormattedData);


        } else {
          setStatusRowData([]);
          setTripsData([]);
          setZoneData([]);
          setDeviceName('');
          setTimePeriod('');
        }
      })();
    }
  }, [getReportId]);

  var countDaysBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const timeDifference = end - start;

    const daysDifference = timeDifference / (1000 * 3600 * 24);

    return Math.abs(daysDifference);
  };



  const exportPDF = async () => {

    if (element) {
      // Temporarily adjust styles to ensure the full content is rendered
      // const originalStyle = { ...element.style }; // Backup original styles
      // console.log("original width : ",element.style.width);

      // element.style.height = `${element.scrollHeight}px`; // Set full height for capturing
      // element.style.overflow = "visible"; // Ensure no scrollbars for html2canvas

      try {
        // Capture the entire content
        const canvas = await html2canvas(element, {
          scale: 2, // High resolution for better quality
          useCORS: true, // Support for cross-origin images
        });

        // Restore original styles
        // Object.assign(element.style, originalStyle);

        // Convert the canvas to an image
        const imgData = canvas.toDataURL("image/png");

        // Initialize jsPDF
        const pdf = new jsPDF("p", "mm", "a4");

        // Calculate dimensions for the PDF
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        // Add content to the PDF and split into pages if necessary
        while (heightLeft > 0) {
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pdfHeight;
          if (heightLeft > 0) {
            pdf.addPage();
            position -= pdfHeight;
          }
        }

        // Save the PDF
        pdf.save("Device_Status_Report_1.pdf");
      } catch (error) {
        console.error("Error generating PDF:", error);
      } finally {
        // Object.assign(element.style, originalStyle);
      }
    } else {
      console.error("reportPdfRef is not attached to a valid DOM element.");
    }
  };

  const exportCSV = () => {
    const rows = [];

    // status table
    rows.push("Current Status");
    rows.push(columnsOptions1.map((col) => col.header).join(","));
    rows.push(
      ...statusRowData.map((row) =>
        columnsOptions1.map((col) => `"${row[col.key] || ""}"`).join(",")
      )
    );
    rows.push("");

    // trips table
    rows.push("Recent Trips");
    rows.push(columnsOptions2.map((col) => col.header).join(","));
    rows.push(
      ...tripsData.map((row) =>
        columnsOptions2.map((col) => `"${row[col.key] || ""}"`).join(",")
      )
    );
    rows.push("");

    // zone table
    rows.push("Zone Activities");
    rows.push(columnsOptions3.map((col) => col.header).join(","));
    rows.push(
      ...zoneData.map((row) =>
        columnsOptions3.map((col) => `"${row[col.key] || ""}"`).join(",")
      )
    );

    const blob = new Blob([rows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "report_tables.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  const getAddress = (latitude, longitude) => {
    return new Promise((resolve, reject) => {
      if (latitude && longitude && window?.google) {
        const geocoder = new window.google.maps.Geocoder();
        const location = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
        geocoder.geocode({ location }, (results, status) => {
          if (status === "OK" && results[0]) {
            resolve(results[0].formatted_address);  // Return the formatted address
          } else {
            console.error("Geocoder failed due to: " + status);
            resolve("-");  // Return a default value in case of failure
          }
        });
      } else {
        resolve("-");
      }
    });
  };

  const _getDistanceByLatLong = async (getStartPointLatitude, getStartPointLongitude, getEndPointLatitude, getEndPointLongitude) => {
    try {
      if (window?.google) {
        const startLatLng = new window.google.maps.LatLng(getStartPointLatitude, getStartPointLongitude);
        const endLatLng = new window.google.maps.LatLng(getEndPointLatitude, getEndPointLongitude);
        const distance = window?.google.maps.geometry.spherical.computeDistanceBetween(startLatLng, endLatLng);

        const distanceInKm = distance / 1000;
        const distanceInMiles = distance / 1609.34;

        return distanceInMiles || '-';
      } else {
        return '-';
      }

    } catch (error) {
      console.log("error ", error);
      return '-';
    }
  }
  const formatDate = async (date) => {
    if (date) {
      date = new Date(date);
      const day = date.getUTCDate();
      const month = MONTHS[date.getUTCMonth()];
      const year = date.getUTCFullYear();
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      const seconds = String(date.getUTCSeconds()).padStart(2, "0");

      const formattedDate = `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
      return formattedDate;
    } else {
      return '-';
    }
  }
  const formatDate2 = (date) => {
    date = new Date(date);
    let formattedDate = date.getUTCDate() + '/' + date.getUTCMonth() + '/' + date.getUTCFullYear();
    return formattedDate;
  }
  const _getDuration = async (startTime, endTime) => {
    const durationInMilliseconds = endTime - startTime;

    const durationInSeconds = durationInMilliseconds / 1000;
    const durationInMinutes = durationInMilliseconds / (1000 * 60);
    const durationInHours = durationInMilliseconds / (1000 * 60 * 60);

    let formattedDuration;

    if (durationInSeconds < 60) {
      formattedDuration = `${Math.round(durationInSeconds)} seconds`;
    } else if (durationInMinutes < 60) {
      formattedDuration = `${Math.round(durationInMinutes)} minutes`;
    } else {
      formattedDuration = `${Math.round(durationInHours)} hours`;
    }

    return formattedDuration || '-';
  }


  return (
    <APIProvider apiKey={GOOGLE_KEY}>
      <div className=" mb-4 mx-5 my-3">
        <div className='pb-3 w-100 d-flex justify-content-between align-items-center'>
          <div className=' ps-1 fs-2'>Report</div>
          {/* <button className='btn btn-dark px-5' onClick={exportPDF}>Export as PDF</button> */}

          <Dropdown>
            <Dropdown.Toggle className="btn btn-dark" id="export-dropdown">
              Export Report
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={exportPDF}><i className='bi bi-file-earmark-pdf'></i> Export as PDF</Dropdown.Item>
              <Dropdown.Item onClick={exportCSV}><i className='bi bi-filetype-csv'></i> Export as CSV</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="card h-100">
          <div className="card-body" ref={reportPdfRef} >
            <div className="row">
              <div className="col-md-12">
                <div className="reports-pdfdata-head">
                  <div className="reports-pdfdata-title">
                    <h3 className="mb-4">
                      Device Name: <span>{deviceName}</span>
                    </h3>
                    <h3>
                      Time Period: <span>{timePeriod}</span>
                    </h3>
                  </div>
                  <div className="reports-pdfdata-logo">
                    <img src={reportpdfLogo} alt="reportpdfLogo" />
                  </div>
                </div>
              </div>
            </div>
            {statusRowData?.length > 0 ?
              <ReportsPdfData
                title={'Current Status'}
                columnsOptions={columnsOptions1}
                rowData={statusRowData}
              />
              : <></>}
            {tripsData?.length > 0 ?
              <ReportsPdfData
                title={'Recent Trips'}
                columnsOptions={columnsOptions2}
                rowData={tripsData} />
              : <></>}
            {zoneData?.length > 0 ?
              <ReportsPdfData
                title={'Zone Activity'}
                columnsOptions={columnsOptions3}
                rowData={zoneData}
              /> : <></>
            }
          </div>
        </div>
      </div>
    </APIProvider>
  )
}

export default ReportPdf